import { syncFormPost } from '../../base/syncForm'
import type { OrderPay, OrderDetail } from './types'

const BaseUrl = process.env.VUE_APP_BASE_API
// 同步提交信息
export const orderFormPost = (data: OrderPay) => syncFormPost('/confirm/bank', data)
// 获取订单详情
export const getOrderDetails = (orderId: string, status: number): Promise<OrderDetail> => fetch(`${BaseUrl}/findPayTypeDetails?key=${orderId}&status=${status}`).then((res) => res.json())
